const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' })
const timeOnly = new Intl.DateTimeFormat(undefined, { timeStyle: 'short' })
const dateOnly = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' })
const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' })

export function formatDateTime(value: string | Date | null | undefined): string {
	return value ? dateTime.format(new Date(value)) : '—'
}

export function formatDate(value: string | Date | null | undefined): string {
	if (!value) return '—'
	return dateOnly.format(
		typeof value === 'string' && value.length === 10 ? new Date(`${value}T12:00:00`) : new Date(value),
	)
}

/** "3 hours ago", "yesterday", … */
export function formatRelative(value: string | Date | null | undefined, now = Date.now()): string {
	if (!value) return '—'
	const seconds = (new Date(value).getTime() - now) / 1000
	const units: [Intl.RelativeTimeFormatUnit, number][] = [
		['day', 86_400],
		['hour', 3600],
		['minute', 60],
	]
	for (const [unit, size] of units)
		if (Math.abs(seconds) >= size) return relative.format(Math.round(seconds / size), unit)
	return 'just now'
}

export function formatCount(n: number | null | undefined): string {
	return n === null || n === undefined ? '—' : n.toLocaleString()
}

export function formatTime(value: Date): string {
	return timeOnly.format(value)
}
